import api from '../api/account.js'
import auth from '../utils/auth.js'
import {setSlotsFavicon} from '../utils/favicon'
import qs from 'qs'
import router from '../router'


export default {
 

  checkIP (state) {
    api.getUserLocation().then(res => {
      if (res.data.State === 1) {
        state.userLocationCode = res.data.Value
      }
    }
    )
  },

  testPlatform (state) {
    if (window.top === window.self) {
      state.platform = 'Web'
    } else if (window.top !== window.self && location.href.includes('cumulus')) {
      state.platform = 'LegendHill'
    } else {
      state.platform = 'Facebook'
    }
  },
  loggingStatus (state) {
    api.getLoginUserInfo({
      version: Math.random()
    }).then(res => {
      let base = '$__BASE_URL_GAMES/'
  
      if (res.data.State === 1 && res.data.Value.IsLogined) {
        if (res.data.Value.LastPlayedPlatform === 'slots') {
          setSlotsFavicon()
        }

        if (!location.href.includes('reset')) {
          if (!res.data.Value.IsBindLz) {
            router.push({ path: '/username' })
          } else if (!res.data.Value.IsBindAvatar) {
            router.push({ path: '/avatar' })
          } else {
            const redirectTo = qs.parse(window.location.search, { ignoreQueryPrefix: true }).r

            state.isLogin = true
            if (redirectTo) {
              window.location.href = redirectTo
            } else if (window.location.hostname.includes('freereelslots')) {
              window.location.href = '$__BASE_URL_GAMES'
            } else {
              const rewardUrl = auth.getCookie('rewardUrl')
              if (rewardUrl && rewardUrl.trim()) {
                window.location.href = base + 'poker/?' + rewardUrl
              } else if (res.data.Value.LastPlayedPlatform === 'slots') {
                window.location.href = base
                  .replace('://staging-games.', '://staging-slots.')
                  .replace('://games.', '://slots.')
                return
              } else {
                window.location.href = base + 'poker'
              }
            }
          }
        }
      }
    })
  },
  faceBookLogin (state) {
    console.log("faceBookLogin")
    FB.login(function (response) {
      if (response.authResponse) {
        if (response.status === 'connected') {
          let userId = response.authResponse.userID
          let accessToken = response.authResponse.accessToken
          let platformNum = 0
          if (accessToken) {
            let baseURL = '$__BASE_URL_NAPI/'
            const params = {
              accessToken: accessToken,
              userid: userId,
              expiresIn: response.authResponse.expiresIn,
              platform: platformNum
            }
            // referrer
            const r = qs.parse(window.location.search, { ignoreQueryPrefix: true }).r
            if (r) {
              params.r = r
            } else if (window.location.hostname.includes('freereelslots')) {
              params.r = '$__BASE_URL_GAMES'
            }
            auth.setCookie('userEmail', 'facebook', 30)
            window.location.href = baseURL + 'webapi/page/facebooklogin/FacebookDialogLogin?' + qs.stringify(params)
            
          }
        }
      } else {
        console.log('User cancelled login or did not fully authorize.')
      }
    }, {
      scope: 'email'
    })
  },

 

  googleLogin (state) {
    console.log("googleLogin")
    if(window.googleClient==null){
      window.googleClient = google.accounts.oauth2.initTokenClient({
        // client_id: '14460564560-l6ld63amkl8lfo2k73lpt4fot1fmm9r3.apps.googleusercontent.com',
        client_id:'$__GOOGLE_CLIENT_ID',
        scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
        callback: (response) => {
          console.log("googleTokenCallback :",response)
          if(response){
            console.log("response")
            let accessToken = response.access_token;
            
            if (accessToken) {
              console.log("location.href  :"+location.href)
              let baseURL = '$__BASE_URL_NAPI/'
              const params = {
                accessToken: accessToken
  
                // expiresIn: response.expiresIn,
                // platform: platformNum
              }
              // referrer
              const r = qs.parse(window.location.search, { ignoreQueryPrefix: true }).r
              console.log("response param r: "+r)
              if (r) {
                params.r = r
              } else if (window.location.hostname.includes('freereelslots')) {
                params.r = '$__BASE_URL_GAMES'
              }
              auth.setCookie('userEmail', 'facebook', 30)
              window.location.href = baseURL + '$__GOOGLE_REDIRECT_URI' + qs.stringify(params)
              console.log("response url :"+window.location.href)
              // window.location.href = 'www.google.com/' + qs.stringify(params)
            }
          }
        }
      });
    }
    
    window.googleClient.requestAccessToken()
  },


  yahooLogin() {
    let baseURL = '$__BASE_URL_NAPI/';

    let client_id = '$__YAHOO_CLIENT_ID'; //线上


    auth.setCookie('userEmail', 'facebook', 30)
    let yahooUrl = "https://api.login.yahoo.com/oauth2/request_auth?"+
    "client_id="+client_id+
    "&response_type=code"+
    "&redirect_uri=" + encodeURIComponent(baseURL+'$__YAHOO_REDIRECT_URI')
    const r = qs.parse(window.location.search, { ignoreQueryPrefix: true }).r
    if (r) {
      yahooUrl += "&state=" + encodeURIComponent(r)
    }
    window.location.href = yahooUrl
    console.log("redirect_uri: "+baseURL+'$__YAHOO_REDIRECT_URI')
    // https://napi.playpokergo.com/WebAPI/page/yahoologin/YahooLogin
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js